import Head from "next/head"
import styles from "./PrivacyPolicy.module.scss"

export const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <Head>
        <link rel="stylesheet" href="/css/privacy.css" />
      </Head>

      <div className={styles.container}>
        <h1 className="c10" id="h.7aclrwtlx4qd">
          <span className="c7">
            END USER LICENSE AGREEMENT AND PRIVACY POLICY FOR TOMBO, INC. - CREATORS OF THE TOMBO APPLICATION
          </span>
        </h1>
        <p className="c0">
          <span className="c3">IMPORTANT - READ CAREFULLY:</span>
        </p>
        <p className="c0">
          <span className="c3">
            This End User License Agreement (&quot;Agreement&quot;) is a legal agreement between you (either an
            individual or a single entity)(&ldquo;user&rdquo; or &ldquo;you&rdquo; or &ldquo;your organization&rdquo; or
            &ldquo;your business&rdquo; or &ldquo;your company&rdquo;) and Tombo, Inc. (&ldquo;Tombo&rdquo;) the creator
            of Tombo, governing your use of the Software Application (&quot;Application&quot; or
            &ldquo;application&rdquo; or &ldquo;software&rdquo; or &ldquo;AI&rdquo; or &ldquo;Artificial
            Intelligence&rdquo;) as well as the acceptable use of the Application for Job Candidates
            (&ldquo;candidates&rdquo;). By clicking on the &quot;I Accept&quot; or &ldquo;I Agree&rdquo; button,
            installing, or using the Application, you agree to be bound by the terms of this Agreement.
          </span>
        </p>
        <h2 className="c1" id="h.681ekaxfi0ob">
          <span className="c5">1. License Grant:</span>
        </h2>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. grants you a non-exclusive, non-transferable, limited license to use the Application in
            accordance with this Agreement. The license is granted solely for the purpose of communications between
            recruiters, HR professionals and job candidates. Furthermore, no communications to job candidates that
            involve the purchase of any goods or services is allowed.
          </span>
        </p>
        <h2 className="c1" id="h.3lpaeqohwzay">
          <span className="c5">2. Changes to Pricing:</span>
        </h2>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. strives to make a useful free version of Tombo, but reserves the right to modify, amend, or
            change the pricing of the Application at any time and without notice, except as may be required by
            applicable law. Any changes to the pricing of the Application will be effective immediately upon posting of
            the updated pricing on the Application, or upon sending you a notice of the changes by email or in-app
            notification.
          </span>
        </p>
        <h2 className="c1" id="h.v5v6nyjdc114">
          <span className="c5">3. Privacy:</span>
        </h2>
        <p className="c0">
          <span className="c3">
            This Privacy Policy section governs the manner in which Tombo, Inc. collects, uses, maintains and discloses
            information collected from users of the AI Software Application (the &quot;Application&quot;). This Privacy
            Policy applies to the Application and all products and services offered by Tombo, Inc.
          </span>
        </p>
        <h3 className="c8" id="h.35cuoasoe3ed">
          <span className="c13 c6">A. Personal Information Collection</span>
        </h3>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. may collect personal identification information from users in a variety of ways, including but
            not limited to, when users visit our site, register on the site, place an order, subscribe to the
            newsletter, respond to a survey, fill out a form, and in connection with other activities, services,
            features or resources we make available on our Application. We will collect personal identification
            information from users only if they voluntarily submit such information to us. Users can always refuse to
            supply personally identifiable information, except that it may prevent them from engaging in certain
            Application-related activities. <br />
            <br />
            For users of the Application, Tombo, Inc. may at its discretion collect such data as: CVs of job candidates,
            online professional profiles, human annotated notes or decisions about CVs and job candidates, data and
            emails between you and job candidates, notes taken about the job candidates, job descriptions connected to
            job candidates and other information used by the Application to assist the User in becoming more efficient
            or improving the Application. Tombo, Inc. may at its discretion use such data to further develop new
            features of the Application that may become paid features in the future.
          </span>
        </p>
        <h3 className="c8" id="h.o6gk01uq0ndm">
          <span className="c13 c6">B. Non-Personal Information Collection</span>
        </h3>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. may collect non-personal identification information about users whenever they interact with our
            Application. Non-personal identification information may include the browser name, the type of computer and
            technical information about users&rsquo; means of connection to our Application, or other information such
            as the operating system and the Internet service providers utilized.
          </span>
        </p>
        <h3 className="c8" id="h.804xvhaxz3uq">
          <span className="c13 c6">C. How We Use Collected Information</span>
        </h3>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. may collect and use users&#39; personal information for the following purposes:
          </span>
        </p>
        <ul className="c19 lst-kix_reazcr51qk9c-0 start">
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              To improve customer service: Information you provide helps us respond to your customer service requests
              and support needs more efficiently.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              To personalize user experience: We may use information in the aggregate to understand how our users as a
              group use the services and resources provided on our Application.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              To improve our Application: We may use feedback you provide to improve our products and services.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              To increase the usefulness of our databases for both training the AI, making the Application better and to
              deliver a better experience to users and job candidates.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              To process payments: We may use the information users provide about themselves when placing an order only
              to provide service to that order.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              To send periodic emails: We may use the email address to send users information and updates pertaining to
              their order. It may also be used to respond to their inquiries, questions, and/or other requests.
            </span>
          </li>
        </ul>
        <h3 className="c8" id="h.jcd96ses84xb">
          <span className="c13 c6">D. Sharing Your Personal Information</span>
        </h3>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. may sell, trade, or rent users&#39; limited personal information of job candidates to users who
            are professional recruiters or HR professionals in order to communicate about job opportunities and
            career-related engagements. We may share generic aggregated demographic information not linked to any
            personal identification information regarding visitors and users with our business partners and may list
            those business partners on tombo.ai.
          </span>
        </p>
        <h3 className="c8" id="h.y6j3tseuvrq2">
          <span className="c6 c13">
            E. Compliance with California Privacy Laws, GDPR, NYC AI Act, CAN SPAM and Other Regulations and
            Non-Acceptable Usage of the Application
          </span>
        </h3>
        <p className="c0">
          <span className="c6">
            Tombo, Inc. is committed to complying with California Privacy Laws, including the California Consumer
            Privacy Act (CCPA). We provide California consumers with the right to access, delete, and opt-out of the
            sale of their personal information. If you are a California consumer and would like to exercise your rights
            under CCPA, please contact us using the information provided in Section 9 to{" "}
          </span>
          <span className="c12 c6">
            <a className="c11" href="mailto:privacy@tombo.ai">
              privacy@tombo.ai
            </a>
          </span>
          <span className="c3">
            .<br />
            <br />
            Tombo, Inc. is committed to complying with the General Data Protection Regulation (GDPR) and ensuring the
            privacy and security of your personal data. Our recruiting application has been designed to have best
            efforts to adhere to GDPR standards, including data minimization, encryption, and the right to erasure. We
            implement reasonable security measures to protect your data and provide you with full control over your
            personal information within the confines of GDPR as it relates to both you as the user and candidates you
            contact, however, Tombo, Inc. can not control how you use Tombo&rsquo;s features and thus can not be
            ultimately liable for how you use the application&rsquo;s messaging and communications features.
            <br />
            <br />
            The New York City AI Act aims to provide a legal framework for the use of automated employment decision
            tools. It is designed to ensure fairness, accountability, and transparency when employers in New York City
            use AI-driven systems to assess job applicants. Tombo, Inc strives to allow you to have features that enable
            you, as part of a broader compliance program within your organization, to partly comply with this act as it
            relates to use of the Application, however - it is up to you or your organization to ensure you are
            following New York City&rsquo;s overall guidelines and framework for full compliance. Tombo, Inc. can only
            supply some features that may allow you to comply in part, but the broader efforts of ensuring compliance
            such as: hiring an audit firm, using objective versus subjective AI-based decisions in hiring or promoting
            employees, obtaining legal consultation, creating compliance policies and responding to candidate applicant
            inquiries are out of the scope of Tombo, Inc&rsquo;s software.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            You also agree that you will not use Tombo for: spam, sales communications, competitive intelligence,
            corporate research, or any other use of the application that does not involve the efforts of sourcing,
            recruiting or staffing job candidates for employment. You agree that you are using the Application as a
            recruiter, sourcer, staffing agent or some form of human resources professional only.
            <br />
            <br />
            By using Tombo you are assuming all liability for violations of the New York City AI Act, the CCPA, GDPR,
            CAN SPAM, TCPA and any other federal, country or local laws and regulations concerning both outbound
            communications to job seekers and compliance with any regulations, acts or laws that pertain to you or your
            business.
          </span>
        </p>
        <h3 className="c8" id="h.h6vjddwy711v">
          <span className="c13 c6">F. Changes to This Agreement</span>
        </h3>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. reserves the right to update this Agreement at any time. When we do, we will revise the updated
            date at the bottom of this page. We encourage users to frequently check this page for any changes to stay
            informed about how we are helping to protect the personal information we collect.
          </span>
        </p>
        <h3 className="c8" id="h.myqwasqmlyjc">
          <span className="c13 c6">G. Your Acceptance of These Terms</span>
        </h3>
        <p className="c0">
          <span className="c3">
            By using this Application, you signify your acceptance of this End User License Agreement and Privacy
            Policy. If you do not agree to this Privacy Policy, please do not use our Application. Your continued use of
            the Application following the posting of changes to this Privacy Policy will be deemed your acceptance of
            those changes.
          </span>
        </p>
        <h3 className="c8" id="h.tnlam0thj58u">
          <span className="c13 c6">H. Contacting Us</span>
        </h3>
        <p className="c0">
          <span className="c6">
            If you have any questions about this Privacy Policy, the practices of this Application, or your dealings
            with this Application, please contact us at:
            <br />
          </span>
          <span className="c6 c9">help@tombo.ai</span>
        </p>
        <h2 className="c1" id="h.gfdq9sklssef">
          <span className="c5">4. Warranties and Representations</span>
        </h2>
        <p className="c0">
          <span className="c3">
            The Application is provided &quot;as is&quot; and Tombo, Inc. makes no warranties or representations of any
            kind, whether express, implied, statutory or otherwise, including without limitation warranties of
            merchantability, fitness for a particular purpose, data accuracy, the accuracy of the AI, and
            non-infringement. You acknowledge that the Application and its AI models may contain errors or bugs and that
            Tombo, Inc. does not warrant that the Application will be error-free or uninterrupted.
          </span>
        </p>
        <p className="c0">
          <span className="c6">
            Tombo, Inc. relies on 3rd party data providers for some of the information processed by the application
            including but not limited to: candidate emails, CVs and profiles of candidates, and other public and private
            data. By using the application you agree that Tombo, Inc. is not in any way liable for inaccuracies in such
            data and that you assume all responsibility and liability for use of the applications and its data whether
            that data is owned by Tombo, Inc. or is obtained thru 3rd party data providers. You can email{" "}
          </span>
          <span className="c6 c15">support</span>
          <span className="c15 c6">
            <a className="c11" href="mailto:privacy@tombo.ai">
              @tombo.ai
            </a>
          </span>
          <span className="c3">
            &nbsp;for a list of potential 3rd party data providers currently used by the application if Tombo, Inc. is
            obligated to provide such data to you in the jurisdiction of your organization, and only if your request
            fully identifies you thru government documentation as well as your organization&rsquo;s legal corporate
            identification and documented legal obligation by Tombo, Inc. to comply with such request.
          </span>
        </p>
        <h2 className="c1" id="h.2i5rk7w6kbkj">
          <span className="c5">5. Email Reading and User Data</span>
        </h2>
        <p className="c0">
          <span className="c3">
            You acknowledge and agree that the Application&rsquo;s AI systems will read your messages to candidates and
            other Application users conducted through the Application as they are processed by the Application in order
            to function and improve the user experience and job candidate experience. You further acknowledge and agree
            that Tombo, Inc. has the right to use such message content and other user data to improve the Application.
            All such data collected by the Application becomes the sole property of Tombo, Inc.
          </span>
        </p>
        <h2 className="c1" id="h.uxonj09h0kun">
          <span className="c5">6. Free and Possible Paid Versions</span>
        </h2>
        <p className="c21">
          <span>
            While Tombo, Inc. strives to make a free version available for all Users, Tombo, Inc. may create paid
            versions of the Application in the future, and may require free Users to upgrade to a paid version should
            their usage create compute fees or support fees that are economically non-viable for Tombo, Inc. to support.
            All potential future pricing will be published.
          </span>
        </p>
        <h2 className="c1" id="h.gsy4t0sd3aiq">
          <span className="c5">7. Termination</span>
        </h2>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. may terminate this Agreement at any time for any reason by notifying you in writing. Upon
            termination, you must immediately cease all use of the Application and destroy all copies of the
            Application. Tombo, Inc. reserves the right to delete all user data and records upon such termination.
          </span>
        </p>
        <h2 className="c1" id="h.vvnvqf78wyjs">
          <span className="c5">8. Limitation of Liability:</span>
        </h2>
        <p className="c0">
          <span className="c3">
            In no event shall Tombo, Inc. be liable for any damages (including, without limitation, damages for
            violations of local, state, federal or country regulations, the loss of business profits, damage to your
            organization&rsquo;s reputation, business interruption, loss of business information, or any other pecuniary
            loss) arising out of the use of or inability to use the Application, even if Tombo, Inc. has been advised of
            the possibility of such damages.
            <br />
            <br />
            In no event shall Tombo, Inc. be liable for: lost emails, lost messages, inaccurate emails, inaccurate
            messages, lost data, misreported data, misused data, stolen data, misappropriated data, damage to you or
            your business, complaints or lawsuits from job candidates as a result of your use of the Application,
            downtime in the Application, fines from government or regulatory agencies or any other damages or
            liabilities caused by the use of Tombo.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            By using the application, you are assuming sole responsibility for the use of Tombo as well as any
            implications, damages, fees, fines, lost wages, lost data or any other damages that may incur as the result
            of using the Application.
            <br />
            <br />
            You understand that AI (or artificial intelligence) may hallucinate content and misreport or misinterpret
            data, and that in no way shall Tombo, Inc. be responsible for any such errors or inaccuracies by the AI
            models used by the Application.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            In the event that a court of competent jurisdiction finds Tombo, Inc. liable for any damages or losses
            arising from your use of the Application, you agree that Tombo, Inc.&#39;s maximum liability to you shall be
            limited to the total amount paid by you to Tombo, Inc. for the Application. This limitation of liability
            shall apply regardless of the form of action, whether in contract, tort, negligence, strict liability, or
            otherwise.
            <br />
            <br />
            You also agree that by using Tombo, you will assume and pay for any court costs and legal costs that Tombo,
            Inc. incurs in the event of a lawsuit or legal complaint or filing against Tombo, Inc. by you or your
            organization should Tombo, Inc. become the prevailing party. You also agree that Tombo, Inc. is entitled to
            any court fees and legal costs incurred because of you or your organization&rsquo;s violation of the terms
            of this Agreement should Tombo, Inc. file a lawsuit or legal complaint against you or your organization and
            should Tombo, Inc. be found to be the prevailing party.
          </span>
        </p>
        <h2 className="c1" id="h.ic0qjmsqxax5">
          <span className="c5">9. Governing Law and Jurisdiction:</span>
        </h2>
        <p className="c0">
          <span className="c3">
            This Agreement shall be governed by and construed in accordance with the laws of the State of Florida, and
            any dispute arising out of or in connection with this Agreement shall be adjudicated in the state or federal
            courts located in Hillsborough County, Tampa, Florida. Each party hereby consents to the exclusive
            jurisdiction of such courts and waives any objections thereto based on venue, inconvenience of the forum, or
            lack of personal jurisdiction.
          </span>
        </p>
        <h2 className="c1" id="h.nxv3rkgf5eqq">
          <span className="c5">10. Compliance with Laws:</span>
        </h2>
        <p className="c0">
          <span className="c3">
            You acknowledge and agree that you will use the Application in compliance with all applicable local and
            federal laws, regulations, and industry standards related to data protection, including but not limited to
            the General Data Protection Regulation (GDPR), CAN SPAM, the New York City AI Act, the EU AI Act, and the
            California Consumer Privacy Act (CCPA). You further acknowledge and agree that both you and Tombo, Inc. have
            implemented appropriate technical and organizational measures to ensure the ownership, compliance of,
            security and confidentiality of personal information processed through the Application.
          </span>
        </p>
        <h2 className="c1" id="h.ezid1dcq90vt">
          <span className="c5">11. Data Controller:</span>
        </h2>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. may at times act as a data controller for the personal information it collects from users of the
            Application. Tombo, Inc. is committed to complying with all applicable local and federal laws related to
            data protection, including but not limited to the GDPR and the CCPA.
          </span>
        </p>
        <h2 className="c1" id="h.duftczsxa4t6">
          <span className="c5">12. User-Generated Data and Feedback:</span>
        </h2>
        <p className="c0">
          <span className="c3">
            If you provide any feedback, suggestions, or ideas to Tombo, Inc. regarding the Application, or if you
            contribute any user-generated data to the Application, including but not limited to candidate information,
            resumes, and communication history, whether through the Application or otherwise, you grant Tombo, Inc. a
            worldwide, non-exclusive, perpetual, irrevocable, royalty-free license to use, copy, modify, create
            derivative works based on, distribute, publicly display, publicly perform, and otherwise exploit in any
            manner such feedback, suggestions, ideas, or user-generated data, without any obligation to compensate you
            or to provide attribution to you.
          </span>
        </p>
        <h2 className="c1" id="h.6bohvly20w2">
          <span className="c5">13. Changes to Agreement</span>
        </h2>
        <p className="c0">
          <span className="c3">
            Tombo, Inc. reserves the right to modify, amend, or change this Agreement at any time and without notice,
            except as may be required by applicable law. Any changes to this Agreement will be effective immediately
            upon posting of the updated Agreement on the Application or tombo.ai. Your continued use of the Application
            after any such changes shall constitute your consent to such changes.
          </span>
        </p>
        <h2 className="c1" id="h.q806u9p090xh">
          <span className="c5">14. Ownership of Data</span>
        </h2>
        <p className="c0">
          <span className="c3">
            You acknowledge that you are providing feedback to Tombo, Inc. for the purpose of improving the accuracy of
            the AI. You further acknowledge and agree that all data, including any feedback, communications with
            candidates and other users, suggestions, or ideas that you provide to Tombo, Inc. regarding the Application,
            whether through the Application or otherwise, may be used to improve the Application, for future features of
            the Application that may be paid features or for some other business purpose.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            By using the Application, you consent to Tombo, Inc.&#39;s collection, use, storage, and disclosure of your
            personal information and user-generated and user uploaded data in accordance with this Agreement and Tombo,
            Inc.&#39;s Privacy Policy. If you do not agree to the terms of this Agreement, do not download or use the
            Application.
          </span>
        </p>
        <h3 className="c8" id="h.s50vzo3z8uqh">
          <span className="c13 c6">15. Prohibited Use</span>
        </h3>
        <p className="c0">
          <span className="c3">Users of the Application are prohibited from engaging in the following activities:</span>
        </p>
        <ul className="c19 lst-kix_ny5ojextlfkn-0 start">
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              Attempting to download or extract any data or information from the Application, including candidate
              information, resumes, and communication history or jailbreak the AI or understand how the AI models work.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              Attempting to share or resell any data or information obtained through the Application;
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              Reverse engineering, decompiling, disassembling, or otherwise attempting to derive the source code of the
              Application.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              Using the Application to sell job candidates on services or products not exclusively related to offering
              employment.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              Using the Application for competitive intelligence, corporate research, or other purposes in an attempt to
              create competing products or services to the Application or Tombo, Inc. in the future.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              Using any data mining, robots, or similar data gathering or extraction methods in connection with the
              Application.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              Impersonating any person or entity, or falsely stating or otherwise misrepresenting your affiliation with
              a person or entity.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              Violating any applicable local, state, national, or international law or regulation, including, without
              limitation, any data protection or privacy laws.
            </span>
          </li>
          <li className="c0 c2 li-bullet-0">
            <span className="c3">
              Interfering with or disrupting the operation of the Application or the servers or networks used to make
              the Application available, including by hacking or defacing any portion of the Application.
            </span>
          </li>
        </ul>
        <p className="c0">
          <span className="c3">
            You agree that you will not use Tombo to steal the Application&rsquo;s code or data, to reverse engineer any
            part of the application, to steal the designs or user experience, or to obtain the identity of the
            application&rsquo;s users or creators. Furthermore, attempting to do so may create significant economic
            damages and opportunity cost to Tombo, Inc. that you or your organization agree to be liable for.
          </span>
        </p>
        <h3 className="c8" id="h.tq6mllfgau7f">
          <span className="c13 c6">16. Intellectual Property Rights</span>
        </h3>
        <p className="c0">
          <span className="c3">
            All intellectual property rights in the Application and any content or data provided through the
            Application, including without limitation candidate information, resumes, and communication history, are
            owned by Tombo, Inc. or its licensors. Users are granted no rights in or to the Application or any such
            content or data other than the limited right to use the Application in accordance with this Agreement.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            Users acknowledge and agree that any violation of the above provisions may result in immediate termination
            of their use of the Application, and may result in legal action against them by Tombo, Inc. or other
            affected parties.
          </span>
        </p>
        <h2 className="c1" id="h.n4wt9kujc2qy">
          <span className="c5">17. Permitted Communications</span>
        </h2>
        <p className="c0">
          <span className="c3">
            Users of the Application may communicate with job candidates for the sole purpose of discussing job
            opportunities and relevant job-related information. Under no circumstances may recruiters or users of the
            Application send non job-offer related messages to job candidates thru the Application.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            Users of the Application are responsible for complying with all applicable laws and regulations related to
            electronic communication, including but not limited to the CAN-SPAM Act and the Telephone Consumer
            Protection Act (TCPA) as well as GDPR. Users must ensure that all messages sent through the Application
            comply with such laws and regulations, including by providing accurate and truthful information about the
            identity of the sender and including an opt-out mechanism for recipients which can be inserted by you as a
            call to action or a link within the email settings of the Application.
          </span>
        </p>
        <p className="c0">
          <span className="c3">
            Users acknowledge and agree that any violation of the above provisions may result in immediate termination
            of their use of the Application, loss of their data, and may result in legal action against them by Tombo,
            Inc. or other affected parties.
          </span>
        </p>
        <p className="c0">
          <span className="c6">Users and others can contact Tombo, Inc. at </span>
          <span className="c6 c12">
            <a className="c11" href="mailto:help@tombo.ai">
              help@tombo.ai
            </a>
          </span>
          <span className="c3">&nbsp;</span>
        </p>
        <p className="c0">
          <span className="c17">LAST POSTED OCTOBER 31, 2023</span>
        </p>
      </div>
    </>
  )
}
